import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

export interface SubmitContactUsFormApiParameter extends ApiParameter {
    firstname?: string;
    lastname?: string;
    title?: string;
    companyname?: string;
    street?: string;
    city?: string;
    mobile?: string;
    areaofinterest?: string;
    industry?: string;
    note?: string;
    email?: string;
    phone?: string;
    state?: string;
    zip?: string;
    isemailnewsletteroptin?: string;
    formtype?: string;
    isoutsideususer?: string;
}

export function submitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return post<SubmitContactUsFormApiParameter>(`api/v1/customcontactforms`, parameter);
}
